import { logout, trackEvent } from "utils";

export function handleUnauthorized(details: { endpoint: string }) {
  trackEvent("Unauthorized Request", details);
  logout();
}
